import { createChartWithCategory } from './create'
import { deleteChart } from './delete'
import { updateChart } from './update'

export const charts = {
  createWithCategory: createChartWithCategory,
  delete: deleteChart,
  update: updateChart,
}
